/* 
 * マイスポット登録用JavaScript
 * 参照元：http://ghe.aws01.mapion.co.jp/mapiondev/contents/blob/master/mapion_smartphone/js/map/myspot_api.js
 */
var MySpot = function(){
	var url = `${process.env.REACT_APP_BASE_URL}/api/v1/myspots`;
  var {$} = window;

	function post(access_token, param, success, error){
		return $.ajax({
			type        : 'POST',
			url         : url,
			headers     : {'Authorization' : 'Bearer ' + access_token},
			data        : JSON.stringify({myspot : {poi_code : param.poi_code, name : param.name, address : param.address, location : { lat : param.lat, lng : param.lng }}}),
			dataType    : 'json',
			contentType : 'application/json',
			cache       : false,
			statusCode  : {
				201: function() {
					success && success({result:201});
				},
				400: function() {
					success && success({result:400});
				},
				401: function() {
					success && success({result:401});
				}
			}
		});
	}

	function get(access_token, poi_code, success, error){
		$.ajax({
			type        : 'GET',
			url         : url + '/' + poi_code,
			headers     : {'Authorization' : 'Bearer ' + access_token},
			dataType    : 'json',
			contentType : 'application/json',
			statusCode  : {
				200: function() {
					success && success({result:200});
				},
				401: function() {
					success && success({result:401});
				},
				404: function() {
					success && success({result:404});
				}
			},
			error       : function(XMLHttpRequest, textStatus, errorThrown){
				error && error(errorThrown);
			}
		});
	}
	

	return {
		post : post,
		get : get
	};
}();
export default MySpot;